// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"1bf00da7","647":"0df5930f"}[chunkId] + ".chunk.js";
};